import {ComponentPortal} from "@angular/cdk/portal";
import {Injectable, Type} from "@angular/core";
import {SearchScopeEnum} from "../../../shared/enums/search-scope.enum";
import {EmptySearchParamsFilterModel} from "../../../shared/models/search/params/filters/empty-search-params-filter.model";
import {SearchResultsFilterModel} from "../../../shared/models/search/results/filters/search-results-filter.model";
import {SearchResultItemModel} from "../../../shared/models/search/results/items/search-result-item.model";
import {SearchResultModel} from "../../../shared/models/search/results/search-result.model";
import {MediaTabComponent} from "../../components/tabs/media-tab/media-tab.component";
import {ProductsTabComponent} from "../../components/tabs/products-tab/products-tab.component";
import {SearchTabDirective} from "../../components/tabs/search-tab.directive";
import {UmbracoPagesTabComponent} from "../../components/tabs/umbraco-pages-tab/umbraco-pages-tab.component";
import {ScopedSearchResultModel} from "../../models/search-results/scoped-search-result.model";

@Injectable({
    providedIn: "root"
})
export class TabFactoryService {
    public resolveTabTypeForScope(scope: SearchScopeEnum)
        : Type<SearchTabDirective<EmptySearchParamsFilterModel, ScopedSearchResultModel<SearchResultItemModel, SearchResultsFilterModel>>>  {

        let tab: Type<SearchTabDirective<EmptySearchParamsFilterModel, ScopedSearchResultModel<SearchResultItemModel, SearchResultsFilterModel>>>  = null;

        switch (scope) {
            case SearchScopeEnum.Product: {
                tab = ProductsTabComponent;
                break;
            }
            case SearchScopeEnum.Media: {
                tab = MediaTabComponent;
                break;
            }
            case SearchScopeEnum.Service: {
                tab = UmbracoPagesTabComponent;
                break;
            }
            case SearchScopeEnum.Other: {
                tab = UmbracoPagesTabComponent;
                break;
            }
            default:
                throw new Error("Unknown search scope.");
        }

        return tab;
    }

    public createTabPortal(scope: SearchScopeEnum)
        : ComponentPortal<SearchTabDirective<EmptySearchParamsFilterModel, ScopedSearchResultModel<SearchResultItemModel, SearchResultsFilterModel>>> {

        const tab = this.resolveTabTypeForScope(scope);

        return new ComponentPortal(tab);
    }
}
